module.exports = __webpack_public_path__ + "media/prepaid-cards/prepaid-5000-with-gift-d54a51df.png";